/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper';
import clsx from 'clsx'
import { KTSVG } from '../../_metronic/helpers';
import { Col, Row, Table } from 'react-bootstrap-v5';
import validationErrorMsg from '../helpers/ValidationErrorMsg'
import Swal from 'sweetalert2'
import showLoader from '../helpers/ShowLoader'
import 'react-dropzone-uploader/dist/styles.css'
import axios, { AxiosResponse, AxiosError } from 'axios'
import Dropzone from 'react-dropzone-uploader'
import { useParams } from 'react-router-dom'
import ShipmentCreate from '../components/ShipmentCreate'
import ProductReturn from '../components/ProductReturn'
import EditSr from '../components/EditSr'
import EditSalesOrderItem from '../components/EditSalesOrderItem'
import EditSalesOrderFreeItem from '../components/EditSalesOrderFreeItem'
import SalesPaymentCreate from '../components/SalesPaymentCreate'
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom'
import { useContext } from 'react'
import { AppContext } from '../context/AppContext';

interface SalesOrder {
    editPermission: boolean;
    deletePermission: boolean;
    id_sales_orders: number;
    idSalesOrders: number;
    createdBy: number;
    idProjects: number;
    idLeads: number;
    createdAt: any;
    salesOrderDate: string;
    shippingAddress: string;
    billingAddress: string;
    purchaseOrderNo: string;
    requisitionNo: string;
    salesType: string;
    remarks: string;
    idSr: number;
    salesOrderId: string;
    sales_representative: any;
    creditDays: number;
    creditDaysFrom: string;
    idSalesQuotations: number;
    totalDiscount: number;
    orderAmount: number;
    leadName: string;
    projectName: string;
    companyName?: string;
    idCompanies?: number;
    shipments_sum_shipment_amount: number;
    payments_sum_payment_amount: number;
    invoices_sum_invoice_amount: number;
    status: string;
    approvedAt: string;
    creator: {
        name: string;
        id_sr_categories: number;
    };
    approver: {
        name: string;
    };
    upazila: {
        name: string;
    };
    district: {
        name: string;
    };
    terms: { id_sales_orders: number, terms_clause: string }[];
    comments: { id_sales_orders: number, comment: string, created_at: string, creator: any }[];
    attachments: {
        id_sales_orders: number, attachment_name: string, attachment_path: string
        , file_size: number, created_at: string, creator: any
    }[];
    rows: {
        id_sales_orders: number, id_product_group_alternate_names: number, unit_rate: number
        , quantity: number, discount_percent: number, product_name: string, original_rate: number
        , already_delivered: string, unit_rate_without_transportation: number, transportation_cost: number, product: any, unit: any
    }[];
    freeRows: {
        id_sales_orders: number, id_product_group_alternate_names: number
        , quantity: number, product_name: string
        , already_delivered: string, product: any, unit: any
    }[];

    project: {
        projectName: string;
    };
    company: any;
    quotation: {
        referenceNumber: string;
    };
    shipments: {
        id_shipments: number, shipment_date: string, chalan_no: string, shipping_address: string
        , vehicle_no: string, driver_name: string, driver_phone_no: string
        , rows: {
            quantity: string; sales_order_row: any;
        }[]
        , free_rows: {
            quantity: string; sales_order_free_row: any;
        }[]
    }[];
    sales_order_returns: {
        id_sales_order_returns: number, return_date: string, remarks: string, warehouse?: { name: string }, rows: {
            quantity: string; sales_order_row: any;
        }[]
    }[];
    invoices: {
        id_sales_invoice: number, invoice_id: string, invoice_date: number, invoice_amount: number, created_by: string
    }[];
    payments: {
        id_sales_payments: number, transaction_id: string, id_sales_invoice: number, payment_amount: number, creator: any
        , payment_date: string, payment_method: string, payment_type: string, remarks: string, paymentInfo: string
    }[];
    activities?: {
        id: number;
        action: string;
        refType: string;
        refId: number;
        remarks: string | null;
        createdAt: string;
        userName: string | null;
        referenceLabel: string | null;
    }[];
}

interface RouteParams {
    idSalesOrders: string;
}

const getReadableFileSizeString = (fileSizeInBytes: number) => {
    return ((fileSizeInBytes / (1024 * 1024)).toFixed(4) + " MB");
}

const tabTitleWithCount = (label: string, count?: number | null, badgeClass = 'badge-primary') => (
    <span className="d-inline-flex align-items-center">
        {label}
        <span className={`badge badge-circle ${badgeClass} ms-2`}>{count ?? 0}</span>
    </span>
)

const getActivityStyle = (action: string) => {
    switch (action) {
        case 'Order Created':
            return { badge: 'badge-light-primary', icon: '/media/svg/icons/Shopping/Cart1.svg', iconBg: 'bg-light-primary' };
        case 'Order Approved':
            return { badge: 'badge-light-success', icon: '/media/svg/icons/Navigation/Check.svg', iconBg: 'bg-light-success' };
        case 'Order Denied':
            return { badge: 'badge-light-danger', icon: '/media/svg/icons/Navigation/Close.svg', iconBg: 'bg-light-danger' };
        case 'Order Updated':
            return { badge: 'badge-light-info', icon: '/media/svg/icons/Communication/Write.svg', iconBg: 'bg-light-info' };
        case 'Shipment Created':
            return { badge: 'badge-light-warning', icon: '/media/svg/icons/Shopping/Box2.svg', iconBg: 'bg-light-warning' };
        case 'Invoice Created':
            return { badge: 'badge-light-primary', icon: '/media/svg/icons/Files/File.svg', iconBg: 'bg-light-primary' };
        case 'Invoice Updated':
            return { badge: 'badge-light-info', icon: '/media/svg/icons/Files/File.svg', iconBg: 'bg-light-info' };
        case 'Payment Received':
            return { badge: 'badge-light-success', icon: '/media/svg/icons/Shopping/Dollar.svg', iconBg: 'bg-light-success' };
        case 'Payment Updated':
            return { badge: 'badge-light-info', icon: '/media/svg/icons/Shopping/Dollar.svg', iconBg: 'bg-light-info' };
        case 'Return Created':
            return { badge: 'badge-light-danger', icon: '/media/svg/icons/Navigation/Arrow-from-right.svg', iconBg: 'bg-light-danger' };
        case 'Return Deleted':
            return { badge: 'badge-light-danger', icon: '/media/svg/icons/General/Trash.svg', iconBg: 'bg-light-danger' };
        default:
            return { badge: 'badge-light-secondary', icon: '/media/svg/icons/General/Clipboard.svg', iconBg: 'bg-light-secondary' };
    }
}

const formatActivityDate = (dateTime: string) => {
    if (!dateTime) {
        return '';
    }

    const date = new Date(dateTime.replace(' ', 'T'));
    if (Number.isNaN(date.getTime())) {
        return dateTime;
    }

    return date.toLocaleString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    });
}

export function SaledOrderDetails(props: any) {

    const { currentUser } = useContext(AppContext);
    const [tab, setTab] = useState('Sidebar')
    const [salesOrderInfo, setSalesOrderInfo] = useState<SalesOrder | null>(null);
    const { idSalesOrders }: RouteParams = useParams();

    const numberFormat = (value: any) => {

        value = parseFloat(value)
        if (typeof (value) !== 'number') {
            return value;
        }
        return parseFloat(value.toString()).toLocaleString('en-US', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    const [createShipmentModalShow, setCreateShipmentModalShow] = useState(false);
    const [productReturnModalShow, setProductReturnModalShow] = useState(false);
    const [createPaymentModalShow, setCreatePaymentModalShow] = useState(false);
    const [editSrModalShow, setEditSrModalShow] = useState(false);
    const [editItemModalShow, setEditItemModalShow] = useState(false);
    const [editFreeItemModalShow, setEditFreeItemModalShow] = useState(false);
    const handleCreateShipmentModalClose = (isReload: boolean) => {
        setCreateShipmentModalShow(false);
        getSalesOrderInfo();
    }
    const handleProductReturnModalClose = (isReload: boolean) => {
        setProductReturnModalShow(false);
        getSalesOrderInfo();
    }
    const handleCreatePaymentModalClose = (isReload: boolean) => {
        setCreatePaymentModalShow(false);
        getSalesOrderInfo();
    }
    const handleEditSrModalClose = (isReload: boolean) => {
        setEditSrModalShow(false);
        getSalesOrderInfo();
    }
    const handleEditItemModalClose = (isReload: boolean) => {
        setEditItemModalShow(false);
        getSalesOrderInfo();
    }
    const handleEditFreeItemModalClose = (isReload: boolean) => {
        setEditFreeItemModalShow(false);
        getSalesOrderInfo();
    }

    const handleShipmentModalShow = (salesOrderInfo: any) => {
        setSalesOrderInfo(salesOrderInfo);
        setCreateShipmentModalShow(true);
    }

    const handleReturnModalShow = (salesOrderInfo: any) => {
        setSalesOrderInfo(salesOrderInfo);
        setProductReturnModalShow(true);
    }

    const handlePaymentModalShow = (salesOrderInfo: any) => {
        setSalesOrderInfo(salesOrderInfo);
        setCreatePaymentModalShow(true);
    }

    const handleEditSrModalShow = (salesOrderInfo: any) => {
        setSalesOrderInfo(salesOrderInfo);
        setEditSrModalShow(true);
    }

    const handleEditItemModalShow = (salesOrderInfo: any) => {
        setEditItemModalShow(true);
    }

    const handleEditFreeItemModalShow = () => {
        setEditFreeItemModalShow(true);
    }

    let history = useHistory();

    const deleteSalesOrder = (idSalesOrders: any) => {
        if (window.confirm("Are you sure you want to delete this Sales Order?")) {
            const myToken: string | null = localStorage.getItem('MyToken');
            let jwt: string | null = (myToken != null) ? JSON.parse(myToken) : null;
            fetch(`${process.env.REACT_APP_API_URL}sales-order/${idSalesOrders}`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwt}` }
            })
                .then((resp: Response) => {
                    return resp.json();
                })
                .then((resp: any) => {
                    if (resp.success) {
                        const successMsg: string = resp.successMessage;
                        Swal.fire({
                            icon: 'success',
                            title: 'Deleted!',
                            text: successMsg,
                        });
                        history.push('/sales-orders');
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Delete Failed',
                            text: resp.errorMessage,
                        });
                    }
                })
                .catch((error: any) => {
                    console.log(error, 'catch the hoop');
                });
        }

    }

    const approveSalesOrder = async (idSalesOrders: any) => {
           
        const confirm = await Swal.fire({
            title: 'Are you sure?',
            text: "You want to Approve this Sales Order?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ec008c',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Yes, Approve it!',
        })
        if (confirm.value) {
            
            try {
                const requestOptions = postRequestOptions({idSalesOrders: idSalesOrders, status: 'Approved'})
                let response = await fetch(
                    `${process.env.REACT_APP_API_URL}sales-order/update-status`,
                    requestOptions
                )
                let respData = await response.json()
                if (respData.success === true) {
                    const successMsg = respData.successMessage
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: successMsg,
                    })     
                    getSalesOrderInfo()                              
                } else {
                    const errorsMessage = validationErrorMsg(respData.errors).join('<br>')
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        html: errorsMessage,
                    })
                }                    
            } catch (error) {                    
                console.log(error, 'catch the hoop')                    
            }
        }
    }

    const denySalesOrder = async (idSalesOrders: any) => {
           
        const confirm = await Swal.fire({
            title: 'Are you sure?',
            text: "You want to Deny this Sales Order?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ec008c',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Yes, Deny it!',
        })
        if (confirm.value) {
            
            try {
                const requestOptions = postRequestOptions({idSalesOrders: idSalesOrders, status: 'Denied'})
                let response = await fetch(
                    `${process.env.REACT_APP_API_URL}sales-order/update-status`,
                    requestOptions
                )
                let respData = await response.json()
                if (respData.success === true) {
                    const successMsg = respData.successMessage
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: successMsg,
                    })       
                    getSalesOrderInfo()                 
                } else {
                    const errorsMessage = validationErrorMsg(respData.errors).join('<br>')
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        html: errorsMessage,
                    })
                }                    
            } catch (error) {                    
                console.log(error, 'catch the hoop')                    
            }
        }
    }

    const [message, setMessage] = useState('')

    useEffect(() => {
        if (idSalesOrders !== undefined) {
            getSalesOrderInfo();
        }
    }, [idSalesOrders])

    const getSalesOrderInfo = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'sales-order/' + idSalesOrders,
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                const data: SalesOrder = resp.data;
                data.projectName = resp.data.project?.projectName ?? resp.data.project?.project_name;
                data.editPermission = resp.editPermission;
                data.deletePermission = resp.deletePermission;
                data.freeRows = resp.data.free_rows;
                // Add explicit fields for SalesPaymentCreate component
                data.companyName = resp.data.company?.company_name ?? resp.data.company?.companyName;
                data.idCompanies = resp.data.id_companies ?? resp.data.idCompanies;
                data.idProjects = resp.data.id_projects ?? resp.data.idProjects;
                data.activities = resp.activities ?? [];
                setSalesOrderInfo(data);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const sendMessage = async () => {
        showLoader()
        const formData = {
            idSalesOrders: idSalesOrders,
            message: message
        };
        const requestOptions = postRequestOptions(formData)
        try {
            let response = await fetch(
                `${process.env.REACT_APP_API_URL}sales-order/comment`,
                requestOptions
            )
            let respData = await response.json()
            Swal.close();
            if (respData.success === true) {
                setMessage('');
                getSalesOrderInfo()
            } else {
                const errorsMessage = validationErrorMsg(respData.errors).join('<br>')
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    html: errorsMessage,
                })
            }

        } catch (error) {
            console.log(error, 'catch the hoop')
            Swal.close();
        }
    }

    const jwt = () => {
        const myToken = localStorage.getItem('MyToken');
        return (myToken != null) ? JSON.parse(myToken) : null;
    }


    const handleFileSubmit = (files: any, allFiles: []) => {
        showLoader()

        const postFormData = new FormData();
        postFormData.append('idSalesOrders', idSalesOrders.toString());
        for (let i = 0; i < files.length; i++) {
            postFormData.append('files[]', files[i].file);
        }

        const url: string = `${process.env.REACT_APP_API_URL}sales-order/file-upload`;

        axios({
            method: 'POST',
            url: url,
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: 'Bearer ' + jwt(),
            },
            data: postFormData,
        })
            .then((response: AxiosResponse<any>) => {
                Swal.close();
                allFiles.forEach((f: any) => f.remove());
                getSalesOrderInfo();
            })
            .catch((error: AxiosError<any>) => {
                Swal.close();
                // const errorMessage: string = error.response?.data?.errorMessage;
                const errorsMessage: string = validationErrorMsg(error?.response?.data?.errors).join('<br>');
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    html: errorsMessage,
                });
            });

    }


    const deleteSalesInvoice = (idSalesInvoice: number) => {
        if (window.confirm("Are you sure you want to delete this Sales Invoice?")) {
            const myToken: string | null = localStorage.getItem('MyToken');
            let jwt: string | null = (myToken != null) ? JSON.parse(myToken) : null;
            fetch(`${process.env.REACT_APP_API_URL}sales-invoice/${idSalesInvoice}`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwt}` }
            })
                .then((resp: Response) => {
                    return resp.json();
                })
                .then((resp: any) => {
                    if (resp.success) {
                        const successMsg: string = resp.successMessage;
                        Swal.fire({
                            icon: 'success',
                            title: 'Deleted!',
                            text: successMsg,
                        });
                        getSalesOrderInfo()
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Delete Failed',
                            text: resp.errorMessage,
                        });
                    }
                })
                .catch((error: any) => {
                    console.log(error, 'catch the hoop');
                });
        }
    }

    const deleteShipment = (idShipments: number) => {
        if (window.confirm("Are you sure you want to delete this Shipment?")) {
            const myToken: string | null = localStorage.getItem('MyToken');
            let jwt: string | null = (myToken != null) ? JSON.parse(myToken) : null;
            fetch(`${process.env.REACT_APP_API_URL}shipment/${idShipments}`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwt}` }
            })
                .then((resp: Response) => {
                    return resp.json();
                })
                .then((resp: any) => {
                    if (resp.success) {
                        const successMsg: string = resp.successMessage;
                        Swal.fire({
                            icon: 'success',
                            title: 'Deleted!',
                            text: successMsg,
                        });
                        getSalesOrderInfo()
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Delete Failed',
                            text: resp.errorMessage,
                        });
                    }
                })
                .catch((error: any) => {
                    console.log(error, 'catch the hoop');
                });
        }
    }

    const deleteProductReturn = (idSalesOrderReturns: number) => {
        if (window.confirm("Are you sure you want to delete this Product Return?")) {
            const myToken: string | null = localStorage.getItem('MyToken');
            let jwt: string | null = (myToken != null) ? JSON.parse(myToken) : null;
            fetch(`${process.env.REACT_APP_API_URL}sales-order-return/${idSalesOrderReturns}`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwt}` }
            })
                .then((resp: Response) => {
                    return resp.json();
                })
                .then((resp: any) => {
                    if (resp.success) {
                        const successMsg: string = resp.successMessage;
                        Swal.fire({
                            icon: 'success',
                            title: 'Deleted!',
                            text: successMsg,
                        });
                        getSalesOrderInfo()
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Delete Failed',
                            text: resp.errorMessage,
                        });
                    }
                })
                .catch((error: any) => {
                    console.log(error, 'catch the hoop');
                });
        }
    }

    return (<>
        <div className='card card-custom'>
            <div className='card-header card-header-stretch overflow-auto'>
                <div className='card-title'>
                    <h3 className='card-label'>Saled Order Details</h3>
                    <small className='text-muted'>| Information about the sales Order</small>
                </div>
            </div>
            <div className="card-body">

            </div>
        </div>

        <Tabs
            defaultActiveKey="orderInfo"
            id="uncontrolled-tab-example"
            className="mb-3"
        >
            <Tab eventKey="orderInfo" title="Order Details">
                <Row>
                    <Col md={4} className="pe-0 pt-0">
                        <div className="card card-flush overflow-hidden m-2 me-0">
                            <div className="card-header py-5">
                                <h3 className="card-title align-items-start flex-column">
                                    <span className="card-label fw-bold text-dark">Summary</span>
                                </h3>
                                {salesOrderInfo?.editPermission && salesOrderInfo.status !== 'Denied' &&
                                    <button className="btn btn-light-primary btn-sm pull-right" onClick={() => handleEditSrModalShow(salesOrderInfo)}>
                                        <KTSVG
                                            path='/media/svg/icons/Communication/Write.svg'
                                            className='svg-icon-5 svg-icon'
                                        />		Edit
                                    </button>
                                }
                            </div>
                            <div className="card-body pt-0">
                                {/* <pre>{JSON.stringify(salesOrderInfo, null, 2)}</pre> */}
                                <Table striped bordered hover size='sm'>
                                    <tbody>
                                        <tr>
                                            <td style={{ width: '50%' }}>ID</td>
                                            <td style={{ width: '50%' }}>{salesOrderInfo?.id_sales_orders}</td>
                                        </tr>
                                        <tr>
                                            <td>Sales Order ID</td>
                                            <td>{salesOrderInfo?.salesOrderId}</td>
                                        </tr>
                                        <tr>
                                            <td>Project</td>
                                            <td>{salesOrderInfo?.project?.projectName}</td>
                                        </tr>
                                        <tr>
                                            <td>Lead</td>
                                            <td>{salesOrderInfo?.leadName}</td>
                                        </tr>
                                        <tr>
                                            <td>Date</td>
                                            <td>{salesOrderInfo?.salesOrderDate}</td>
                                        </tr>
                                        <tr>
                                            <td>Billing Address</td>
                                            <td>{salesOrderInfo?.billingAddress}</td>
                                        </tr>
                                        <tr>
                                            <td>Shipping Address</td>
                                            <td>{salesOrderInfo?.shippingAddress}</td>
                                        </tr>
                                        <tr>
                                            <td>Credit Days</td>
                                            <td>{salesOrderInfo?.creditDays} from {salesOrderInfo?.creditDaysFrom}</td>
                                        </tr>
                                        <tr>
                                            <td>Sales Representative</td>
                                            <td>
                                                {salesOrderInfo?.sales_representative !== null ? (salesOrderInfo?.sales_representative?.first_name + ' ' + salesOrderInfo?.sales_representative?.last_name) : ''}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Purcahse Order No</td>
                                            <td>{salesOrderInfo?.purchaseOrderNo}</td>
                                        </tr>
                                        <tr>
                                            <td>Requisition No</td>
                                            <td>{salesOrderInfo?.requisitionNo}</td>
                                        </tr>
                                        <tr>
                                            <td>Sales Type</td>
                                            <td>{salesOrderInfo?.salesType}</td>
                                        </tr>
                                        <tr>
                                            <td>Remarks</td>
                                            <td>{salesOrderInfo?.remarks}</td>
                                        </tr>
                                        <tr>
                                            <td>Quotation</td>
                                            <td>{salesOrderInfo?.quotation?.referenceNumber}</td>
                                        </tr>
                                        <tr>
                                            <td>Creator</td>
                                            <td>{salesOrderInfo?.creator.name + ' at ' + salesOrderInfo?.createdAt}</td>
                                        </tr>
                                        <tr>
                                            <td>Upazila</td>
                                            <td>{salesOrderInfo?.upazila?.name}</td>
                                        </tr>
                                        <tr>
                                            <td>District</td>
                                            <td>{salesOrderInfo?.district?.name}</td>
                                        </tr>
                                        <tr>
                                            <td>Status</td>
                                            <td> 
                                                {salesOrderInfo?.status} 
                                                {salesOrderInfo?.status !== 'Created' && salesOrderInfo?.approver &&
                                                    <>{' by '+salesOrderInfo?.approver.name + ' at ' + salesOrderInfo?.approvedAt}</>
                                                }
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </div>

                        <div className="card card-flush overflow-hidden m-2 me-0">
                            <div className="card-header py-5">
                                <h3 className="card-title align-items-start flex-column">
                                    <span className="card-label fw-bold text-dark">Lead Details</span>
                                </h3>
                            </div>
                            <div className="card-body pt-0">
                                <Table striped bordered hover size='sm'>
                                    <tbody>
                                        <tr>
                                            <td style={{ width: '50%' }}>Lead Name</td>
                                            <td style={{ width: '50%' }}>{salesOrderInfo?.leadName}</td>
                                        </tr>
                                        <tr>
                                            <td>Client</td>
                                            <td>{salesOrderInfo?.company?.company_name}</td>
                                        </tr>
                                        <tr>
                                            <td>Category</td>
                                            <td>{salesOrderInfo?.company?.company_category?.category_name}</td>
                                        </tr>
                                        <tr>
                                            <td>Address</td>
                                            <td>{salesOrderInfo?.company?.company_address}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </div>

                        <div className='card card-custom'>
                            <div className='card-header card-header-stretch overflow-auto'>
                                <ul
                                    className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap'
                                    role='tablist'
                                >
                                    <li className='nav-item p-2'>
                                        <a
                                            className={clsx(`nav-link cursor-pointer`, { active: tab === 'Sidebar' })}
                                            onClick={() => setTab('Sidebar')}
                                            role='tab'
                                        >
                                            <KTSVG className='svg-icon-3 me-2' path="/media/svg/icons/Communication/Chat6.svg"></KTSVG>
                                            Add comment
                                        </a>
                                    </li>
                                    <li className='nav-item p-2'>
                                        <a
                                            className={clsx(`nav-link cursor-pointer`, { active: tab === 'Toolbar' })}
                                            onClick={() => setTab('Toolbar')}
                                            role='tab'
                                        >
                                            <KTSVG className='svg-icon-3 me-2' path="/media/svg/icons/General/Clip.svg"></KTSVG>
                                            Attach files
                                        </a>
                                    </li>
                                </ul>
                            </div>


                            <div className='card-body'>
                                <div className='tab-content pt-3'>
                                    <div className={clsx('tab-pane', { active: tab === 'Sidebar' })}>

                                        <Table striped bordered hover size='sm'>
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '50%' }}>Comment</th>
                                                    <th style={{ width: '50%' }}>Comment By</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {salesOrderInfo?.comments?.length === 0 &&
                                                    <tr>
                                                        <td colSpan={2}>No comments available</td>
                                                    </tr>
                                                }
                                                {salesOrderInfo?.comments?.map((comment, index) => (
                                                    <tr>
                                                        <td key={'comment' + index}>{comment.comment}</td>
                                                        <td>{comment.creator.first_name + ' ' + comment.creator.last_name + ' at ' + comment.created_at}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                        <textarea
                                            className='form-control  mb-3'
                                            rows={3}
                                            data-kt-element='input'
                                            placeholder='Type a message'
                                            value={message}
                                            onChange={(e) => setMessage(e.target.value)}
                                        ></textarea>
                                        <div className='d-flex flex-row justify-content-end'>

                                            <button
                                                className='btn-sm btn-success'
                                                type='button'
                                                onClick={sendMessage}
                                            >
                                                Send
                                            </button>
                                        </div>
                                    </div>

                                    <div className={'p-0 ' + clsx('tab-pane', { active: tab === 'Toolbar' })}>

                                        <Table striped bordered hover size='sm'>
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '50%' }}>Attachment</th>
                                                    <th style={{ width: '50%' }}>Uploaded By</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {salesOrderInfo?.attachments?.length === 0 &&
                                                    <tr>
                                                        <td colSpan={2}>No File Attached</td>
                                                    </tr>
                                                }
                                                {salesOrderInfo?.attachments?.map((attachment, index) => (
                                                    <tr>
                                                        <td key={'attachment' + index}>
                                                            <a rel='noreferrer' href={process.env.REACT_APP_AWS_URL + "salesOrders/" + attachment.attachment_path}
                                                                className="fs-6 text-hover-primary fw-bold" target="_blank">{attachment.attachment_name}</a>
                                                            <div className="text-gray-400">{getReadableFileSizeString(attachment.file_size)}</div>
                                                        </td>
                                                        <td>{attachment.creator.first_name + ' ' + attachment.creator.last_name + ' at ' + attachment.created_at}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>

                                        <Dropzone
                                            styles={{ dropzone: { border: "none" } }}
                                            accept='image/*,audio/*,application/pdf'
                                            onSubmit={handleFileSubmit}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>

                    </Col>
                    <Col md={8} className="pt-2">

                        <div className="card card-flush overflow-hidden m-2 me-0">
                            <div className="card-header py-5">
                                <h3 className="card-title align-items-start flex-column">
                                    <span className="card-label fw-bold text-dark">Items</span>
                                </h3>
                                {salesOrderInfo?.editPermission && salesOrderInfo?.shipments.length === 0 && salesOrderInfo.status !== 'Denied' &&
                                    <div className='card-toolbar'>
                                        <button className="btn btn-light-primary btn-sm pull-right" onClick={() => handleEditItemModalShow(salesOrderInfo)}>
                                            <KTSVG
                                                path='/media/svg/icons/Communication/Write.svg'
                                                className='svg-icon-5 svg-icon'
                                            />		Edit
                                        </button>
                                    </div>
                                }
                            </div>
                            <div className="card-body pt-0">
                                <div className="table-responsive">
                                <Table striped bordered hover size="sm">
                                    <thead>
                                        <tr>
                                            <th className='text-center'>SL</th>
                                            <th>Product</th>
                                            {Number(salesOrderInfo?.idProjects) === 3 && <th>Product Code</th>}
                                            <th>Packing</th>
                                            <th>Unit</th>
                                            <th>Order Quantity</th>
                                            <th>Already Delivered</th>
                                            {currentUser?.id_roles !== 13 && currentUser?.id_roles !== 15 && (
                                                <>
                                                    {salesOrderInfo?.project?.showWeight === 'Yes' && <th>Weight (KG)</th>}
                                                    <th>Original Rate (Per Unit)</th>
                                                    <th>Discount(%)</th>
                                                    <th>Rate After Discount</th>
                                                    {salesOrderInfo?.project?.showTransportationCost !== 'No' && <th>Transportation Cost (Per Unit)</th>}
                                                    {salesOrderInfo?.project?.showEffectiveRate !== 'No' && <th>Effective Rate (Rate + Transportation Cost)</th>}
                                                    <th>Amount</th>
                                                    <th>Amount after Discount</th>
                                                </>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {salesOrderInfo?.rows?.map((item, index) => (
                                            <>
                                                <tr key={'item' + index}>
                                                    <td className='text-center'>{index + 1}</td>
                                                    <td>{item?.id_product_group_alternate_names !== null ? item?.alternate_name.alternate_name : item?.product.product_name}</td>
                                                    {Number(salesOrderInfo?.idProjects) === 3 && (
                                                        <td>{item?.product?.product_code || '-'}</td>
                                                    )}
                                                    <td>{item?.product.packing + ' ' + item?.product.item.unit.unit_name}</td>
                                                    <td>{item?.product.unit?.unit_name}</td>
                                                    <td className='text-center'>{item?.quantity}</td>
                                                    <td className='text-center'>{item?.already_delivered}</td>
                                                    {currentUser?.id_roles !== 13 && currentUser?.id_roles !== 15 && (
                                                        <>
                                                            {salesOrderInfo?.project?.showWeight === 'Yes' && (
                                                                <td className='text-end'>
                                                                    {item?.weight_in_kg != null && item?.weight_in_kg !== ''
                                                                        ? numberFormat(item.weight_in_kg)
                                                                        : '-'}
                                                                </td>
                                                            )}
                                                            <td className='text-end'>{numberFormat(item?.original_rate)}</td>
                                                            <td className='text-end'>{item?.discount_percent}</td>
                                                            <td className='text-end'>{numberFormat(item?.unit_rate_without_transportation)}</td>
                                                            {salesOrderInfo?.project?.showTransportationCost !== 'No' && <td className='text-end'>{numberFormat(item?.transportation_cost)}</td>}
                                                            {salesOrderInfo?.project?.showEffectiveRate !== 'No' && <td className='text-end'>{numberFormat(item?.unit_rate)}</td>}
                                                            <td className='text-end'>{numberFormat(item?.quantity * item?.original_rate)}</td>
                                                            <td className='text-end'>{numberFormat((item?.quantity * item?.unit_rate))}</td>
                                                        </>
                                                    )}
                                                </tr>
                                            </>

                                        ))}
                                        {Number(salesOrderInfo?.idProjects) === 3 && (salesOrderInfo?.rows?.length ?? 0) > 0 && (() => {
                                            const totalOrderQuantity = salesOrderInfo.rows.reduce(
                                                (sum, item) => sum + parseFloat(String(item?.quantity ?? 0)),
                                                0
                                            );
                                            const optionalColSpan =
                                                (salesOrderInfo?.project?.showTransportationCost !== 'No' ? 1 : 0)
                                                + (salesOrderInfo?.project?.showEffectiveRate !== 'No' ? 1 : 0)
                                                + (salesOrderInfo?.project?.showWeight === 'Yes' ? 1 : 0);
                                            const trailingColSpan = currentUser?.id_roles !== 13 && currentUser?.id_roles !== 15
                                                ? 6 + optionalColSpan
                                                : 1;

                                            return (
                                                <tr>
                                                    <td colSpan={5} className='text-end'><b>Total Order Quantity :</b></td>
                                                    <td className='text-center'><b>{totalOrderQuantity}</b></td>
                                                    <td colSpan={trailingColSpan}></td>
                                                </tr>
                                            );
                                        })()}
                                        {currentUser?.id_roles !== 13 && currentUser?.id_roles !== 15 && (
                                            <>
                                                {(() => {
                                                    const totalColSpan = 10
                                                        + (Number(salesOrderInfo?.idProjects) === 3 ? 1 : 0)
                                                        + (salesOrderInfo?.project?.showTransportationCost !== 'No' ? 1 : 0)
                                                        + (salesOrderInfo?.project?.showEffectiveRate !== 'No' ? 1 : 0)
                                                        + (salesOrderInfo?.project?.showWeight === 'Yes' ? 1 : 0);
                                                    return (
                                                        <>
                                                            <tr>
                                                                <td colSpan={totalColSpan} className='text-end'><b>Total Amount : </b></td>
                                                                <td className='text-end'><b>{numberFormat(salesOrderInfo?.orderAmount)}</b></td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={totalColSpan} className='text-end'><b>Total Discount : </b></td>
                                                                <td className='text-end'><b>{numberFormat(salesOrderInfo?.totalDiscount)}</b></td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={totalColSpan} className='text-end'><b>Net Amount : </b></td>
                                                                <td className='text-end'><b>{numberFormat((salesOrderInfo?.orderAmount || 0) - (salesOrderInfo?.totalDiscount || 0))}</b></td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={totalColSpan} className='text-end'><b>Total Shipment Amount : </b></td>
                                                                <td className='text-end'><b>{numberFormat(salesOrderInfo?.shipments_sum_shipment_amount)}</b></td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={totalColSpan} className='text-end'><b>Total Invoiced Amount : </b></td>
                                                                <td className='text-end'><b>{numberFormat(salesOrderInfo?.invoices_sum_invoice_amount)}</b></td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={totalColSpan} className='text-end'><b>Total Payment Received : </b></td>
                                                                <td className='text-end'><b>{numberFormat(salesOrderInfo?.payments_sum_payment_amount)}</b></td>
                                                            </tr>
                                                        </>
                                                    );
                                                })()}
                                            </>
                                        )}

                                    </tbody>
                                </Table>
                                </div>
                                <div className='row'> 

                                    {/* {salesOrderInfo?.status === 'Created' && (currentUser && (salesOrderInfo?.creator.id_sr_categories === currentUser.id_sr_categories) && (currentUser.id_roles === 2 || currentUser.id_roles === 3 || currentUser.id_roles === 4))  && */}
                                    {salesOrderInfo?.status === 'Created' &&
                                        currentUser &&
                                        (
                                            currentUser.id_roles === 4 || 
                                            (currentUser.id_roles === 3 && salesOrderInfo?.creator.id_sr_categories === currentUser.idSrCategories)
                                        ) && (
                                        <div className='col text-center'>
                                            <button className="btn btn-primary btn-sm" onClick={() => approveSalesOrder(idSalesOrders)}>
                                                <KTSVG
                                                    path='/media/svg/icons/Navigation/Check.svg'
                                                    className='svg-icon-5 svg-icon'
                                                />		Approve
                                            </button>
                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                            <button className="btn btn-primary btn-sm" onClick={() => denySalesOrder(idSalesOrders)}>
                                                <KTSVG
                                                    path='/media/svg/icons/Code/Stop.svg'
                                                    className='svg-icon-5 svg-icon'
                                                />		Deny
                                            </button>
                                        </div>
                                    )}

                                    {salesOrderInfo?.status === 'Approved' &&
                                        <div className='col text-center'>

                                            <button className="btn btn-primary btn-sm" onClick={() => handleShipmentModalShow(salesOrderInfo)}>
                                                <KTSVG
                                                    path='/media/svg/icons/Shopping/Cart3.svg'
                                                    className='svg-icon-5 svg-icon'
                                                />		Create Shipment
                                            </button>
                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                            <Link className="btn btn-primary btn-sm" to={`/sales-invoice-create?idSalesOrder=${salesOrderInfo?.id_sales_orders}&idProjects=${salesOrderInfo?.idProjects}&projectName=${salesOrderInfo?.project?.projectName}`}>
                                                <KTSVG
                                                    path='/media/svg/icons/Communication/Clipboard-list.svg'
                                                    className='svg-icon-5 svg-icon'
                                                />		Create Invoice
                                            </Link>
                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                            <button className="btn btn-primary btn-sm" onClick={() => handlePaymentModalShow(salesOrderInfo)}>
                                                <KTSVG
                                                    path='/media/svg/icons/Shopping/Dollar.svg'
                                                    className='svg-icon-5 svg-icon'
                                                />		Make Payment
                                            </button>

                                            {salesOrderInfo?.shipments.length !== 0 &&
                                                <>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                                    <button className="btn btn-primary btn-sm" onClick={() => handleReturnModalShow(salesOrderInfo)}>
                                                        <KTSVG
                                                            path='/media/svg/icons/Media/Repeat.svg'
                                                            className='svg-icon-5 svg-icon'
                                                        />		Product Return
                                                    </button>
                                                </>
                                            }
                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                            {salesOrderInfo?.deletePermission &&
                                                <button className="btn btn-primary btn-sm" onClick={() => deleteSalesOrder(idSalesOrders)}>
                                                    <KTSVG
                                                        path='/media/svg/icons/General/Trash.svg'
                                                        className='svg-icon-5 svg-icon'
                                                    />		Delete
                                                </button>
                                            }
                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                            <a className="btn btn-primary btn-sm" target="_blank" rel="noopener noreferrer" href={`${process.env.REACT_APP_BACKEND}salesOrderDownload/${idSalesOrders}`}>
                                                <KTSVG
                                                    path='/media/svg/icons/Files/Downloads-folder.svg'
                                                    className='svg-icon-5 svg-icon'
                                                />		Download
                                            </a>

                                        </div>
                                    }

                                    {salesOrderInfo?.status === 'Denied' &&
                                        <div className='col text-center'>

                                            <span className='text-danger'>This Sales Order has been denied!</span>

                                        </div>
                                    }
                                </div>
                            </div>
                        </div>

                        
                        <div className="card card-flush overflow-hidden m-2 me-0">
                            <div className="card-header py-5">
                                <h3 className="card-title align-items-start flex-column">
                                    <span className="card-label fw-bold text-dark">Free Items</span>
                                </h3>
                                {salesOrderInfo?.editPermission && salesOrderInfo?.shipments?.length === 0 && salesOrderInfo.status !== 'Denied' &&
                                    <div className='card-toolbar'>
                                        <button className="btn btn-light-primary btn-sm pull-right" onClick={() => handleEditFreeItemModalShow()}>
                                            <KTSVG
                                                path='/media/svg/icons/Communication/Write.svg'
                                                className='svg-icon-5 svg-icon'
                                            />		Edit
                                        </button>
                                    </div>
                                }
                            </div>
                            <div className="card-body pt-0">
                                <Table striped bordered hover size="sm">
                                    <thead>
                                        <tr>
                                            <th className='text-center'>SL</th>
                                            <th>Product</th>
                                            {Number(salesOrderInfo?.idProjects) === 3 && <th>Product Code</th>}
                                            <th>Packing</th>
                                            <th>Unit</th>
                                            <th>Quantity</th>
                                            <th>Already Delivered</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {salesOrderInfo?.freeRows?.map((item, index) => (
                                            <>
                                                <tr key={'item' + index}>
                                                    <td className='text-center'>{index + 1}</td>
                                                    <td>{item?.id_product_group_alternate_names !== null ? item?.alternate_name.alternate_name : item?.product.product_name}</td>
                                                    {Number(salesOrderInfo?.idProjects) === 3 && (
                                                        <td>{item?.product?.product_code || '-'}</td>
                                                    )}
                                                    <td>{item?.product.packing + ' ' + item?.product.item.unit.unit_name}</td>
                                                    <td>{item?.product.unit?.unit_name}</td>
                                                    <td className='text-center'>{item?.quantity}</td>
                                                    <td className='text-center'>{item?.already_delivered}</td>
                                                </tr>
                                            </>
                                        ))}
                                        {salesOrderInfo?.freeRows?.length === 0 &&
                                        <tr>
                                            <td colSpan={6} className='text-center'>No free items added</td>
                                        </tr>
                                        }
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                        

                        <div className="card card-flush overflow-hidden m-2 me-0">
                            <div className="card-header py-5">
                                <h3 className="card-title align-items-start flex-column">
                                    <span className="card-label fw-bold text-dark">Terms & Conditions</span>
                                </h3>
                            </div>
                            <div className="card-body pt-0">
                                <Table striped bordered hover size="sm">
                                    <tbody>

                                        {salesOrderInfo?.terms?.length === 0 &&
                                            <tr>
                                                <td colSpan={2}>No terms/conditions added</td>
                                            </tr>
                                        }
                                        {salesOrderInfo?.terms?.map((term, index) => (
                                            <tr>
                                                <td width={'5%'} className='text-center'>{index + 1}</td>
                                                <td width={'95%'} key={index}>{term?.terms_clause}</td>
                                            </tr>
                                        ))}

                                    </tbody>
                                </Table>
                            </div>
                        </div>

                    </Col>
                </Row>
                {salesOrderInfo && salesOrderInfo.status !== 'Denied' &&
                    <>
                        <ShipmentCreate show={createShipmentModalShow} handleClose={handleCreateShipmentModalClose} salesOrderInfo={salesOrderInfo} />
                        <ProductReturn show={productReturnModalShow} handleClose={handleProductReturnModalClose} salesOrderInfo={salesOrderInfo} />
                        <EditSr show={editSrModalShow} handleClose={handleEditSrModalClose} salesOrderInfo={salesOrderInfo} />
                        <EditSalesOrderItem show={editItemModalShow} handleClose={handleEditItemModalClose} salesOrderInfo={salesOrderInfo} />
                        <EditSalesOrderFreeItem show={editFreeItemModalShow} handleClose={handleEditFreeItemModalClose} salesOrderInfo={salesOrderInfo} />
                        <SalesPaymentCreate show={createPaymentModalShow} handleClose={handleCreatePaymentModalClose} salesOrderInfo={salesOrderInfo} />
                    </>
                }
            </Tab>
            {salesOrderInfo &&
                <Tab eventKey="activities" title={tabTitleWithCount('Activities', salesOrderInfo?.activities?.length, 'badge-info')}>
                    <div className="card card-flush overflow-hidden m-2 me-0 shadow-sm border">
                        <div className="card-header py-4 bg-light">
                            <h3 className="card-title align-items-start flex-column mb-0">
                                <span className="card-label fw-bold text-dark">
                                    <KTSVG className='svg-icon-4 me-2' path="/media/svg/icons/General/Clipboard.svg" />
                                    Activity Timeline
                                </span>
                                <small className="text-muted fw-normal mt-1">
                                    Complete history of actions on this sales order
                                </small>
                            </h3>
                            {(salesOrderInfo?.activities?.length ?? 0) > 0 && (
                                <div className="card-toolbar">
                                    <span className="badge badge-light-primary fs-7">
                                        {salesOrderInfo?.activities?.length} activity(s)
                                    </span>
                                </div>
                            )}
                        </div>
                        <div className="card-body pt-5">
                            {(!salesOrderInfo?.activities || salesOrderInfo.activities.length === 0) ? (
                                <div className="text-center py-10 text-muted">
                                    <KTSVG className='svg-icon-5x text-gray-400 mb-3' path="/media/svg/icons/General/Clipboard.svg" />
                                    <div className="fw-semibold fs-5">No activities yet</div>
                                    <small>Actions like order creation, approval, shipment, invoice, and payment will appear here</small>
                                </div>
                            ) : (
                                <div className="d-flex flex-column gap-3">
                                    {salesOrderInfo.activities.map((activity, index) => {
                                        const style = getActivityStyle(activity.action);
                                        return (
                                            <div
                                                className="d-flex align-items-start p-4 rounded border border-gray-200 bg-white"
                                                key={activity.id ?? index}
                                            >
                                                <div className={`symbol symbol-45px symbol-circle me-4 flex-shrink-0 ${style.iconBg}`}>
                                                    <span className="symbol-label">
                                                        <KTSVG path={style.icon} className="svg-icon-2 svg-icon-primary" />
                                                    </span>
                                                </div>
                                                <div className="flex-grow-1 min-w-0">
                                                    <div className="d-flex flex-wrap align-items-center gap-2 mb-1">
                                                        <span className={`badge ${style.badge} fs-7`}>{activity.action}</span>
                                                        {activity.referenceLabel &&
                                                            <span className="text-gray-800 fw-semibold fs-7">{activity.referenceLabel}</span>
                                                        }
                                                    </div>
                                                    {activity.userName &&
                                                        <div className="text-gray-600 fs-7">
                                                            By <span className="fw-semibold text-gray-800">{activity.userName}</span>
                                                        </div>
                                                    }
                                                    {activity.remarks &&
                                                        <div className="text-muted fs-7 mt-1">{activity.remarks}</div>
                                                    }
                                                </div>
                                                <div className="text-end text-muted fs-7 flex-shrink-0 ps-3" style={{ minWidth: '130px' }}>
                                                    {formatActivityDate(activity.createdAt)}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    </div>
                </Tab>
            }
            {salesOrderInfo && salesOrderInfo.status !== 'Denied' &&
                
                <Tab eventKey="shipmentHistory" title={tabTitleWithCount('Shipment History', salesOrderInfo?.shipments?.length, 'badge-warning')}>
                    <div className="card card-flush overflow-hidden m-2 me-0">
                        <div className="card-header py-5">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label fw-bold text-dark">Items</span>
                            </h3>
                        </div>
                        <div className="card-body pt-0">
                            <Row>
                                <Col>
                                    <Table striped bordered hover size='sm'>
                                        <thead>
                                            <tr>
                                                <th className='text-center' style={{ width: '7%' }}>Shipment ID</th>
                                                <th className='text-center' style={{ width: '7%' }}>Chalan No</th>
                                                <th className='text-center' style={{ width: '7%' }}>Shipment Date</th>
                                                <th className='text-center' style={{ width: '7%' }}>Vehicle No</th>
                                                <th className='text-center' style={{ width: '7%' }}>Driver Name</th>
                                                <th className='text-center' style={{ width: '7%' }}>Driver Phone No</th>
                                                <th style={{ width: '15%' }}>Shipping Address</th>
                                                <th style={{ width: '15%' }}>Product</th>
                                                {Number(salesOrderInfo?.idProjects) === 3 && <th style={{ width: '8%' }}>Product Code</th>}
                                                <th style={{ width: '8%' }}>Packing</th>
                                                <th className='text-center' style={{ width: '7%' }}>Delivered Quantity</th>
                                                {currentUser?.id_roles !== 13 && currentUser?.id_roles !== 15 && (
                                                    <>
                                                        <th className='text-center' style={{ width: '7%' }}>Unit Rate</th>
                                                        <th className='text-center' style={{ width: '7%' }}>Amount</th>
                                                    </>
                                                )}
                                                <th className='text-center' style={{ width: '9%' }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {salesOrderInfo?.shipments?.length === 0 &&
                                                <tr>
                                                    <td colSpan={7}>No Data Found</td>
                                                </tr>
                                            }
                                            {salesOrderInfo?.shipments?.map((shipment, index) => (
                                                <>
                                                {shipment?.rows !== null &&
                                                <>
                                                    <tr>
                                                        <td className='text-center'>{shipment.id_shipments}</td>
                                                        <td className='text-center'>{shipment.chalan_no}</td>
                                                        <td className='text-center'>{shipment.shipment_date}</td>
                                                        <td className='text-center'>{shipment.vehicle_no}</td>
                                                        <td className='text-center'>{shipment.driver_name}</td>
                                                        <td className='text-center'>{shipment.driver_phone_no}</td>
                                                        <td>{shipment.shipping_address}</td>
                                                        <td colSpan={
                                                            (currentUser?.id_roles !== 13 && currentUser?.id_roles !== 15 ? 5 : 3)
                                                            + (Number(salesOrderInfo?.idProjects) === 3 ? 1 : 0)
                                                        }></td>
                                                        <td className='text-center'>
                                                            {salesOrderInfo?.deletePermission &&
                                                                <button className="btn btn-light-danger btn-sm" onClick={() => deleteShipment(shipment.id_shipments)}>
                                                                    <KTSVG
                                                                        path='/media/svg/icons/General/Trash.svg'
                                                                        className='svg-icon-5 svg-icon'
                                                                    />		Delete
                                                                </button>
                                                            }
                                                        </td>
                                                    </tr>

                                                    {shipment?.rows?.map((item, k) => (
                                                        <>                                                        
                                                            <tr>
                                                                <td colSpan={7}></td>
                                                                <td>{item?.sales_order_row?.alternate_name !== null ? item?.sales_order_row?.alternate_name?.alternate_name : item?.sales_order_row?.product?.product_name}</td>
                                                                {Number(salesOrderInfo?.idProjects) === 3 && (
                                                                    <td>{item?.sales_order_row?.product?.product_code || '-'}</td>
                                                                )}
                                                                <td>{item?.sales_order_row?.product?.packing + ' ' + item?.sales_order_row?.product?.item.unit.unit_name}</td>
                                                                <td className='text-center'>{item?.quantity}</td>
                                                                {currentUser?.id_roles !== 13 && currentUser?.id_roles !== 15 && (
                                                                    <>
                                                                        <td className='text-center'>{item?.sales_order_row.unit_rate}</td>
                                                                        <td className='text-center'>{numberFormat(parseFloat(item?.quantity) * item?.sales_order_row.unit_rate)}</td>
                                                                    </>
                                                                )}
                                                                <td></td>
                                                            </tr>                                                        
                                                        </>
                                                    ))}

                                                    {shipment?.free_rows?.map((item, k) => (
                                                        <>                                                        
                                                            <tr>
                                                                <td colSpan={7}></td>
                                                                <td>{item?.sales_order_free_row?.alternate_name !== null ? item?.sales_order_free_row?.alternate_name?.alternate_name : item?.sales_order_free_row?.product?.product_name}</td>
                                                                {Number(salesOrderInfo?.idProjects) === 3 && (
                                                                    <td>{item?.sales_order_free_row?.product?.product_code || '-'}</td>
                                                                )}
                                                                <td>{item?.sales_order_free_row?.product?.packing + ' ' + item?.sales_order_free_row?.product?.item.unit.unit_name}</td>
                                                                <td className='text-center'>{item?.quantity}</td>
                                                                {currentUser?.id_roles !== 13 && currentUser?.id_roles !== 15 ? (
                                                                    <td colSpan={2} className='text-center'>Free Item</td>
                                                                ) : (
                                                                    <td className='text-center'>Free Item</td>
                                                                )}
                                                                <td></td>
                                                            </tr>                                                        
                                                        </>
                                                    ))}
                                                </>
                                                }
                                                </>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Tab>

            }
            {salesOrderInfo && salesOrderInfo.status !== 'Denied' &&

                <Tab eventKey="invoices" title={tabTitleWithCount('Invoices', salesOrderInfo?.invoices?.length, 'badge-primary')}>
                    <div className="card card-flush overflow-hidden m-2 me-0">
                        <div className="card-header py-5">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label fw-bold text-dark">Invoices of this Sales Order</span>
                            </h3>
                        </div>
                        <div className="card-body pt-0">
                            <Row>
                                <Col>
                                    <Table striped bordered hover size='sm'>
                                        <thead>
                                            <tr>
                                                <th className='text-center' style={{ width: '20%' }}>Invoice #</th>
                                                <th className='text-center' style={{ width: '20%' }}>Invoice ID</th>
                                                <th className='text-center' style={{ width: '20%' }}>Invoice Date</th>
                                                {currentUser?.id_roles !== 13 && currentUser?.id_roles !== 15 && (
                                                    <th className='text-center' style={{ width: '20%' }}>Invoice Amount</th>
                                                )}
                                                <th className='text-center' style={{ width: '20%' }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {salesOrderInfo?.shipments?.length === 0 &&
                                                <tr>
                                                    <td colSpan={7}>No Data Found</td>
                                                </tr>
                                            }
                                            {salesOrderInfo?.invoices?.map((invoice, index) => (

                                                <tr>

                                                    <td className='text-center'>{invoice.id_sales_invoice}</td>
                                                    <td className='text-center'>{invoice.invoice_id}</td>
                                                    <td className='text-center'>{invoice.invoice_date}</td>
                                                    {currentUser?.id_roles !== 13 && currentUser?.id_roles !== 15 && (
                                                        <td className='text-center'>{numberFormat(invoice.invoice_amount)}</td>
                                                    )}
                                                    <td className='text-center'>
                                                        {salesOrderInfo?.deletePermission &&
                                                            <button className="btn btn-light-danger btn-sm" onClick={() => deleteSalesInvoice(invoice.id_sales_invoice)}>
                                                                <KTSVG
                                                                    path='/media/svg/icons/General/Trash.svg'
                                                                    className='svg-icon-5 svg-icon'
                                                                />		Delete
                                                            </button>
                                                        }
                                                        <Link className="btn btn-light-primary btn-sm" to={`/sales-invoice/${invoice.id_sales_invoice}`}>
                                                            <KTSVG
                                                                path='/media/svg/icons/Layout/Layout-grid.svg'
                                                                className='svg-icon-5 svg-icon'
                                                            />		Details
                                                        </Link>
                                                        <a className="btn btn-light-primary btn-sm" target="_blank" rel="noopener noreferrer" href={`${process.env.REACT_APP_BACKEND}invoiceDownload/${invoice.id_sales_invoice}`}>
                                                            <KTSVG
                                                                path='/media/svg/icons/Files/Downloads-folder.svg'
                                                                className='svg-icon-5 svg-icon'
                                                            />		Download
                                                        </a>
                                                    </td>
                                                </tr>

                                            ))}
                                            {currentUser?.id_roles !== 13 && currentUser?.id_roles !== 15 && (
                                                <tr>
                                                    <td colSpan={3} className='text-end'><b>Total Invoiced Amount : </b></td>
                                                    <td className='text-center'><b>{numberFormat(salesOrderInfo?.invoices_sum_invoice_amount)}</b></td>
                                                    <td></td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Tab>
            
            }
            {salesOrderInfo && salesOrderInfo.status !== 'Denied' &&
                <Tab eventKey="payments" title={tabTitleWithCount('Payments', salesOrderInfo?.payments?.length, 'badge-success')}>
                    <div className="card card-flush overflow-hidden m-2 me-0 shadow-sm border">
                        <div className="card-header py-4 bg-light">
                            <h3 className="card-title align-items-start flex-column mb-0">
                                <span className="card-label fw-bold text-dark">
                                    <KTSVG className='svg-icon-4 me-2' path="/media/svg/icons/Shopping/Dollar.svg" />
                                    Payments of this Sales Order
                                </span>
                                <small className="text-muted fw-normal mt-1">
                                    Payment records for this order
                                </small>
                            </h3>
                            {(salesOrderInfo?.payments?.length ?? 0) > 0 && currentUser?.id_roles !== 13 && currentUser?.id_roles !== 15 && (
                                <div className="card-toolbar">
                                    <span className="badge badge-light-primary fs-7">
                                        Total Received: {numberFormat(salesOrderInfo?.payments_sum_payment_amount ?? 0)}
                                    </span>
                                    <span className="badge badge-light-info fs-7 ms-2">
                                        {salesOrderInfo?.payments?.length} payment(s)
                                    </span>
                                </div>
                            )}
                        </div>
                        <div className="card-body pt-0">
                            <Row>
                                <Col>
                                    <div className="table-responsive">
                                        <Table striped bordered hover size='sm' className="mb-0">
                                            <thead className="table-light">
                                                <tr>
                                                    <th className='text-center text-nowrap' style={{ width: '6%' }}>ID</th>
                                                    <th className='text-center text-nowrap' style={{ width: '8%' }}>Type</th>
                                                    <th className='text-center text-nowrap' style={{ width: '10%' }}>Method</th>
                                                    <th className='text-center text-nowrap' style={{ width: '8%' }}>Invoice ID</th>
                                                    <th className='text-center text-nowrap' style={{ width: '10%' }}>Date</th>
                                                    {currentUser?.id_roles !== 13 && currentUser?.id_roles !== 15 && (
                                                        <th className='text-end text-nowrap' style={{ width: '10%' }}>Amount</th>
                                                    )}
                                                    <th className='text-start' style={{ width: '10%' }}>Remarks</th>
                                                    <th className='text-center text-nowrap' style={{ width: '10%' }}>Transaction ID</th>
                                                    <th className='text-center text-nowrap' style={{ width: '12%' }}>Payment By</th>
                                                    <th className='text-start' style={{ width: '14%' }}>Payment Info</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(!salesOrderInfo?.payments || salesOrderInfo.payments.length === 0) && (
                                                    <tr>
                                                        <td colSpan={currentUser?.id_roles !== 13 && currentUser?.id_roles !== 15 ? 10 : 9} className="text-center py-8 text-muted">
                                                            <KTSVG className='svg-icon-5x text-gray-400 mb-2' path="/media/svg/icons/Shopping/Wallet.svg" />
                                                            <div className="fw-semibold">No payments yet</div>
                                                            <small>Payments will appear here when received for this order</small>
                                                        </td>
                                                    </tr>
                                                )}
                                                {salesOrderInfo?.payments?.map((payment: any, index: number) => (
                                                    <tr key={payment.id_sales_payments ?? index}>
                                                        <td className='text-center align-middle'>{payment.id_sales_payments}</td>
                                                        <td className='text-center align-middle'>
                                                            <span className={`badge ${payment.payment_type === 'regular' ? 'badge-light-success' : 'badge-light-warning'} fs-7`}>
                                                                {payment.payment_type}
                                                            </span>
                                                        </td>
                                                        <td className='text-center align-middle'>
                                                            <span className="badge badge-light-primary fs-7">
                                                                {payment.payment_method?.replace('_', ' ')}
                                                            </span>
                                                        </td>
                                                        <td className='text-center align-middle'>{payment.id_sales_invoice || '-'}</td>
                                                        <td className='text-center align-middle'>{payment.payment_date}</td>
                                                        {currentUser?.id_roles !== 13 && currentUser?.id_roles !== 15 && (
                                                            <td className='text-end align-middle fw-semibold text-success'>{numberFormat(payment.payment_amount)}</td>
                                                        )}
                                                        <td className='text-start align-middle'>{payment.remarks || '-'}</td>
                                                        <td className='text-center align-middle font-monospace'>{payment.transaction_id || '-'}</td>
                                                        <td className='text-center align-middle'>{(payment.creator?.first_name ?? '') + ' ' + (payment.creator?.last_name ?? '') || '-'}</td>
                                                        <td className='text-start align-middle small'>{payment.paymentInfo || '-'}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            {(salesOrderInfo?.payments?.length ?? 0) > 0 && currentUser?.id_roles !== 13 && currentUser?.id_roles !== 15 && (
                                                <tfoot className="table-light">
                                                    <tr>
                                                        <td colSpan={5} className="text-end fw-bold">Total Payment Amount:</td>
                                                        <td className="text-end fw-bold text-success">
                                                            {numberFormat(salesOrderInfo?.payments_sum_payment_amount ?? 0)}
                                                        </td>
                                                        <td colSpan={4}></td>
                                                    </tr>
                                                </tfoot>
                                            )}
                                        </Table>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Tab>

            }
            {salesOrderInfo && salesOrderInfo.status !== 'Denied' &&

                <Tab eventKey="returnHistory" title={tabTitleWithCount('Return History', salesOrderInfo?.sales_order_returns?.length, 'badge-danger')}>
                    <div className="card card-flush overflow-hidden m-2 me-0">
                        <div className="card-header py-5">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label fw-bold text-dark">Items</span>
                            </h3>
                        </div>
                        <div className="card-body pt-0">
                            <Row>
                                <Col>
                                    <Table striped bordered hover size='sm'>
                                        <thead>
                                            <tr>
                                                <th className='text-center' style={{ width: '7%' }}>Return ID</th>
                                                <th className='text-center' style={{ width: '7%' }}>Shipment Date</th>
                                                <th className='text-center' style={{ width: '10%' }}>Warehouse</th>
                                                <th className='text-center' style={{ width: '7%' }}>Remarks</th>
                                                <th style={{ width: '15%' }}>Product</th>
                                                {Number(salesOrderInfo?.idProjects) === 3 && <th style={{ width: '8%' }}>Product Code</th>}
                                                <th style={{ width: '8%' }}>Packing</th>
                                                <th className='text-center' style={{ width: '7%' }}>Return Quantity</th>
                                                {currentUser?.id_roles !== 13 && currentUser?.id_roles !== 15 && (
                                                    <>
                                                        <th className='text-center' style={{ width: '7%' }}>Unit Rate</th>
                                                        <th className='text-center' style={{ width: '7%' }}>Amount</th>
                                                    </>
                                                )}
                                                <th className='text-center' style={{ width: '9%' }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {salesOrderInfo?.sales_order_returns?.length === 0 &&
                                                <tr>
                                                    <td colSpan={11}>No Data Found</td>
                                                </tr>
                                            }
                                            {salesOrderInfo?.sales_order_returns?.map((returnData, index) => (
                                                <>
                                                    <tr>
                                                        <td rowSpan={returnData?.rows?.length} className='text-center'>{returnData.id_sales_order_returns}</td>
                                                        <td rowSpan={returnData?.rows?.length} className='text-center'>{returnData.return_date}</td>
                                                        <td rowSpan={returnData?.rows?.length} className='text-center'>{returnData.warehouse?.name || '-'}</td>
                                                        <td rowSpan={returnData?.rows?.length} className='text-center'>{returnData.remarks}</td>
                                                        <td>{ (returnData.rows[0].sales_order_row?.alternate_name !== null) ? returnData.rows[0].sales_order_row?.alternate_name?.alternate_name : returnData.rows[0].sales_order_row?.product?.product_name}</td>
                                                        {Number(salesOrderInfo?.idProjects) === 3 && (
                                                            <td>{returnData.rows[0].sales_order_row?.product?.product_code || '-'}</td>
                                                        )}
                                                        <td>{returnData.rows[0].sales_order_row?.product?.packing}</td>
                                                        <td className='text-center'>{returnData.rows[0].quantity}</td>
                                                        {currentUser?.id_roles !== 13 && currentUser?.id_roles !== 15 && (
                                                            <>
                                                                <td className='text-center'>{returnData.rows[0].sales_order_row.unit_rate}</td>
                                                                <td className='text-center'>{numberFormat(parseFloat(returnData.rows[0].quantity) * returnData.rows[0].sales_order_row.unit_rate)}</td>
                                                            </>
                                                        )}
                                                        <td rowSpan={returnData?.rows?.length} className='text-center'>
                                                            {salesOrderInfo?.deletePermission &&
                                                                <button className="btn btn-light-danger btn-sm" onClick={() => deleteProductReturn(returnData.id_sales_order_returns)}>
                                                                    <KTSVG
                                                                        path='/media/svg/icons/General/Trash.svg'
                                                                        className='svg-icon-5 svg-icon'
                                                                    />		Delete
                                                                </button>
                                                            }
                                                        </td>
                                                    </tr>
                                                    {returnData?.rows?.map((item, k) => (
                                                        <>
                                                            {k !== 0 &&
                                                                <tr>
                                                                    <td>{ (item?.sales_order_row?.alternate_name !== null) ? item?.sales_order_row?.alternate_name?.alternate_name : item?.sales_order_row?.product?.product_name}</td>
                                                                    {Number(salesOrderInfo?.idProjects) === 3 && (
                                                                        <td>{item?.sales_order_row?.product?.product_code || '-'}</td>
                                                                    )}
                                                                    <td>{item?.sales_order_row?.product?.packing}</td>
                                                                    <td className='text-center'>{item?.quantity}</td>
                                                                    {currentUser?.id_roles !== 13 && currentUser?.id_roles !== 15 && (
                                                                        <>
                                                                            <td className='text-center'>{item?.sales_order_row.unit_rate}</td>
                                                                            <td className='text-center'>{numberFormat(parseFloat(item?.quantity) * item?.sales_order_row.unit_rate)}</td>
                                                                        </>
                                                                    )}
                                                                </tr>
                                                            }
                                                        </>
                                                    ))}
                                                </>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Tab>
                
            }


        </Tabs>


    </>
    )
}

export default SaledOrderDetails
